import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/scrollPane/styles.scss';export default {
  "scrollPane": "_scrollPane_xmow3_1"
};